import { format } from "date-fns";
import type { AIRecommendationResponse } from "@/types/recommendation";

interface NLQChatbotProps {
  response: AIRecommendationResponse;
}

function formatTime(value?: string | null) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return format(date, "HH:mm:ss");
}

export function NLQChatbot({ response }: NLQChatbotProps) {
  return (
    <div className="space-y-2">
      {response.userMessage && (
        <div className="ml-auto max-w-[70%] rounded-[12px] rounded-tr-[2px] bg-[#DCF2FF] px-3 py-2 text-[13px] leading-[1.4]">
          <div className="whitespace-pre-wrap break-words">{response.userMessage}</div>
          {response.userMessageTimestamp && (
            <div className="mt-1 text-right text-[10px] text-slate-500">
              {formatTime(response.userMessageTimestamp)}
            </div>
          )}
        </div>
      )}

      <div className="max-w-full rounded-[12px] rounded-tl-[2px] bg-[#F5F5F5] px-3 py-2 text-[13px] leading-[1.4]">
        <div className="space-y-2 whitespace-pre-wrap break-words">
          {response.title && <p className="font-semibold">{response.title}</p>}

          {response.options.map((optionBlock, idx) => (
            <div key={`${optionBlock.titleWithOptionDesc}-${idx}`} className="space-y-1">
              <p className="font-semibold">{optionBlock.titleWithOptionDesc}</p>

              {optionBlock.option.length > 0 && (
                <table className="w-[80%] border border-[#e8e8e8] border-collapse text-[13px]">
                  <thead>
                    <tr>
                      <th className="border border-[#e8e8e8] p-2 text-left font-semibold">Date</th>
                      <th className="border border-[#e8e8e8] p-2 text-left font-semibold">Available to Sell</th>
                    </tr>
                  </thead>
                  <tbody>
                    {optionBlock.option.map((dayOption, dayIdx) => (
                      <tr key={`${dayOption.day}-${dayIdx}`}>
                        <td className="border border-[#e8e8e8] p-2">{dayOption.day}</td>
                        <td className="border border-[#e8e8e8] p-2">{dayOption.availability}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          ))}

          {(response.recommendations ?? response.Recommendations ?? []).map((item, idx) => (
            <p key={`rec-${idx}`}>{item}</p>
          ))}

          {(response.question ?? []).map((item, idx) => (
            <p key={`q-${idx}`}>{item}</p>
          ))}
        </div>

        {response.assistantTimestamp && (
          <div className="mt-1 text-left text-[10px] text-slate-500">
            {formatTime(response.assistantTimestamp)}
          </div>
        )}
      </div>
    </div>
  );
}
